import {makeCreator} from '~/misc/dispatch';
import {prepare} from '~/misc/create';
import types from './types';

export const changeDate = makeCreator(types.NOW_DATE_CHANGED);
export const changeMinute = prepare(types.NOW_MINUTE_CHANGED);



// WEBPACK FOOTER //
// ./src/modules/now/actions.js